import { Pedido, ItemPedido } from '../types';
import { Cliente } from '../types';

export const formatarMoeda = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(valor);
};

export const gerarReciboWhatsApp = (
  pedido: Pedido,
  cliente?: Cliente,
  nomeLoja: string = 'Nossa Loja'
): string => {
  const quebra = '\n';
  const ehOrcamento = pedido.status === 'Orçamento';

  let texto = ehOrcamento
    ? `📋 *Orçamento - ${nomeLoja}*` + quebra + quebra
    : `🛒 *Recibo de Compra - ${nomeLoja}*` + quebra + quebra;

  texto += `*Pedido:* #${pedido.id.split('-')[0].toUpperCase()}` + quebra;
  texto +=
    `*Data:* ${new Date(pedido.createdAt || pedido.data || Date.now()).toLocaleDateString('pt-BR')}` +
    quebra;

  if (cliente || pedido.clienteNome) {
    texto += `*Cliente:* ${cliente?.nome || pedido.clienteNome}` + quebra;
  }

  texto += quebra + `*ITENS DO PEDIDO:*` + quebra;

  pedido.itens.forEach((item: ItemPedido) => {
    texto +=
      `▪️ ${item.quantidade}x ${item.produtoNome} - ${formatarMoeda(item.precoUnitario)}` + quebra;
  });

  texto += quebra + `*RESUMO:*` + quebra;
  if (pedido.subtotal !== undefined) {
    texto += `Subtotal: ${formatarMoeda(pedido.subtotal)}` + quebra;
  }
  if (pedido.desconto && pedido.desconto > 0) {
    texto += `Desconto: -${formatarMoeda(pedido.desconto)}` + quebra;
  }
  if (pedido.acrescimo && pedido.acrescimo > 0) {
    texto += `Acréscimo: +${formatarMoeda(pedido.acrescimo)}` + quebra;
  }

  texto += ehOrcamento
    ? `*VALOR DO ORÇAMENTO: ${formatarMoeda(pedido.valorTotal)}*` + quebra + quebra
    : `*TOTAL A PAGAR: ${formatarMoeda(pedido.valorTotal)}*` + quebra + quebra;

  // Status de Pagamento
  if (ehOrcamento) {
    texto += `💬 *Qualquer dúvida é só chamar!* Para confirmar, responda esta mensagem.` + quebra;
  } else if (pedido.status === 'Pago') {
    texto += `✅ *Pagamento Recebido!* Muito obrigado pela compra.` + quebra;
  } else if (pedido.status === 'Pago Parcialmente') {
    texto += `⚠️ *Pagamento Parcial* (Falta: ${formatarMoeda(pedido.saldoDevedor)})` + quebra;
  } else {
    texto += `⏳ *Aguardando Pagamento*` + quebra;
  }

  texto += ehOrcamento
    ? quebra + `Obrigado pela preferência! 💙`
    : quebra + `Obrigado por comprar com a gente! 💙`;

  return texto;
};

export const gerarLinkWhatsApp = (telefone: string, mensagem: string): string => {
  const numeroLimpo = telefone.replace(/\D/g, '');
  // Adiciona código do BR se não tiver
  const numeroComDDI = numeroLimpo.length <= 11 ? `55${numeroLimpo}` : numeroLimpo;
  const link = `https://wa.me/${numeroComDDI}?text=${encodeURIComponent(mensagem)}`;
  return link;
};
